import classNames from 'classnames';

import styles from './styles.module.scss';

/**
 * This component has 4 different grey 'blobs'. It is used to demonstrate what
 * state the order is in. For example, if the current status is Processing Order,
 * then the first grey blob will be highlighted and larger than the rest. Side note,
 * this comp will unhighlight all grey blobs that do not equal the given status.
 * @param props
 */

interface StatusBlobsProps {
  currentStep: number;
  maxSteps: number;
  isShowing: boolean;
}

export const StatusBlobs = ({ currentStep, maxSteps = 4, isShowing = true }: StatusBlobsProps) => {
  if (!isShowing) return null;
  return (
    <>
      <div className={styles.statusBlobs}>
        {Array.from({ length: currentStep }).map((_, index) => (
          <div
            key={`highlightedBlob${index}`}
            className={classNames({
              [styles.highlightedBlob]: true,
            })}
          />
        ))}
        {Array.from({ length: maxSteps - currentStep }).map((_, index) => (
          <div
            key={`unhighlightedBlob${index}`}
            className={classNames({
              [styles.highlightedBlob]: false,
            })}
          />
        ))}
      </div>
    </>
  );
};
